import React from 'react'
import Modal from '@berlitz/modal'
import { H4, RichText } from '@berlitz/globals'
import { PhoneNumber, NumbersList, NumberItem, RichTextStyled } from './style'
import Spacer from '@berlitz/spacer'
import PhoneIcon from '@berlitz/streamline-icons/lib/bold/20-Phones-Mobile-Devices/01-Phone/Phone'
import EmailIcon from '@berlitz/streamline-icons/lib/bold/19-Emails/07-Email-Actions/EmailActionUnread'
import ExpendIcon from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/52-Expand-Retract/Expand6Alternate'
import LinkIcon from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/27-Link-Unlink/Hyperlink2'
import { getSerializedHTML } from '../../functions/utils'

const PhoneModal = ({ modalOpen, setModalOpen, phoneNumbers, modalFooter }) => {
  return (
    <div data-key="phone-modal">
      <Modal onClose={() => setModalOpen(false)} open={modalOpen}>
        <NumbersList data-key="phone-modal__numbers-list">
          {phoneNumbers.map(key => {
            const {
              phone_number: {
                document: {
                  data: { phone_number, title, link_format, phone_description },
                },
              },
              external_link_title,
              external_link_icon,
            } = key
            return (
              <NumberItem
                key={`phone-modal__numbers-list__${title}`}
                data-key={`phone-modal__numbers-list__${title}`}
              >
                <H4 disableMargin>{title}</H4>
                {(() => {
                  switch (link_format) {
                    case 'email':
                      return (
                        <>
                          <PhoneNumber
                            href={`mailto:${phone_number.replace(' ', '')}`}
                          >
                            <EmailIcon color="brand01" size="xs" />
                            <Spacer left size="xs">
                              {phone_number}
                            </Spacer>
                          </PhoneNumber>
                          <Spacer bottom size="xs" />
                        </>
                      )
                    case 'custom link':
                      return (
                        <>
                          <PhoneNumber
                            href={`${phone_number.replace(' ', '')}`}
                            target="_blank"
                          >
                            {external_link_icon == 'phone' && (
                              <PhoneIcon size="xs" color="brand01" />
                            )}
                            {external_link_icon == 'mail' && (
                              <EmailIcon size="xs" color="brand01" />
                            )}
                            {external_link_icon == 'external_link' && (
                              <ExpendIcon size="sm" color="brand01" />
                            )}
                            {external_link_icon == 'internal_link' && (
                              <LinkIcon size="sm" color="brand01" />
                            )}
                            <Spacer left size="xs">
                              {external_link_title}
                            </Spacer>
                          </PhoneNumber>
                          <Spacer bottom size="xs" />
                        </>
                      )
                    case 'description only':
                      return null
                    default:
                      return (
                        <>
                          <PhoneNumber
                            href={`tel:${phone_number.replace(' ', '')}`}
                          >
                            <PhoneIcon size="xs" color="brand01" />
                            <Spacer left size="xs">
                              {phone_number}
                            </Spacer>
                          </PhoneNumber>
                          <Spacer bottom size="xs" />
                        </>
                      )
                  }
                })()}
                {phone_description.html && (
                  <RichTextStyled
                    dangerouslySetInnerHTML={{
                      __html: getSerializedHTML(phone_description.richText),
                    }}
                  />
                )}
              </NumberItem>
            )
          })}
        </NumbersList>

        {modalFooter && (
          <>
            <Spacer bottom size="lg" />
            <RichText dangerouslySetInnerHTML={{ __html: modalFooter }} />
          </>
        )}
      </Modal>
    </div>
  )
}

export default PhoneModal
